import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n'; // Initialize i18n
import { CmsProvider } from './cms/CmsProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CmsProvider>
      <App />
    </CmsProvider>
  </React.StrictMode>
);